<script>
export default {
  name: 'ClientOnly',
  data() {
    return {
      mounted: false,
    };
  },
  mounted() {
    this.mounted = true;
  },
  render() {
    if (!this.mounted) return null;
    // render the default slot directly, no wrapper element
    return this.$slots.default ? this.$slots.default[0] : null;
  },
};
</script>
